import React from 'react';
import { Box, Checkbox, CircularProgress } from '@mui/material';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useDispatch } from 'react-redux';
import { showToast } from '@/features/toast/toastSlice';
import {
	useDeleteTaskMutation,
	useUpdateTaskMutation,
} from '@/features/engagements/engagementsApi';

const GradientCheckbox = ({ completed, onChange, disabled }) => {
	return (
		<Checkbox
			disabled={disabled}
			icon={
				<>
					<svg width={0} height={0}>
						<linearGradient id='linearColors' x1={0} y1={1} x2={1} y2={1}>
							<stop offset={0} stopColor='rgba(131,214,255,1)' />
							<stop offset={1} stopColor='rgba(229,132,255,1)' />
						</linearGradient>
					</svg>
					<CheckCircleOutlineRoundedIcon sx={{ fill: 'url(#linearColors)' }} />
				</>
			}
			checkedIcon={
				<>
					<svg width={0} height={0}>
						<linearGradient id='linearColors2' x1={0} y1={1} x2={1} y2={1}>
							<stop offset={0} stopColor='rgba(131,214,255,1)' />
							<stop offset={1} stopColor='rgba(229,132,255,1)' />
						</linearGradient>
					</svg>
					<CheckCircleRoundedIcon sx={{ fill: 'url(#linearColors2)' }} />
				</>
			}
			checked={Boolean(completed)}
			onClick={(e) => e.stopPropagation()}
			onChange={onChange}
		/>
	);
};

export const DataGridTaskStatus = ({ row }) => {
	const dispatch = useDispatch();
	const [updateTask, { isLoading }] = useUpdateTaskMutation({ fixedCacheKey: row.id });
	const [_deleteTask, { isLoading: isDeleteLoading }] = useDeleteTaskMutation({
		fixedCacheKey: row.id,
	});

	const { completed, id, dealId, clientId, objectType } = row;

	const handleCompleteTask = async () => {
		if (!id) return;

		try {
			await updateTask({
				dealId,
				clientId,
				taskId: id,
				objectType,
				properties: {
					status: completed ? 'NOT_STARTED' : 'COMPLETED',
				},
			}).unwrap();
		} catch (err) {
			console.error('Error updating task', err);
			dispatch(
				showToast({
					message: `Error updating task: ${err?.error ?? 'Please try again'}`,
					error: true,
				}),
			);
		}
	};

	if (isLoading) {
		return (
			<Box padding='0.76rem'>
				<CircularProgress size='1rem' />
			</Box>
		);
	}

	return (
		<Box width='50px' sx={{ display: 'flex', justifyContent: 'center' }}>
			<GradientCheckbox
				completed={completed}
				onChange={handleCompleteTask}
				disabled={isLoading || isDeleteLoading}
			/>
		</Box>
	);
};
